import TalkImg from "../../assets/talk.jpg";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

export default function Talks() {
  return (
    <div className="flex flex-col md:flex-row fade-in justify-center gap-4 md:gap-8 mx-auto py-8 px-2 md:px-4 max-h-[550px] max-w-[90%] rounded-lg">
      <a
        target="_blank"
        className="w-full block"
        href="https://www.epicweb.dev/talks/whats-new-in-react-19-and-how-to-use-it"
        rel="noreferrer"
      >
        <img
          alt="Epic Web Dev Talk"
          className="block mx-auto mb-4 outline outline-1 rounded-lg outline-neutral-700 w-full"
          src={TalkImg}
        />
      </a>
      <div className="flex flex-col gap-2">
        <h3 className="text-lg w-full">Whats new in React 19</h3>
        <p className="text-gray-500 my-2 mx-auto text-justify">
          In this talk, we explore the new features introduced in React 19,
          highlighting improvements in performance, efficiency, and developer
          experience. We cover:&nbsp;
          <span className="text-neutral-200">
            React Compiler, Server Components, Server Functions, form hooks, the
            use API
          </span>
          &nbsp;and much more.
        </p>
        <div className="flex flex-col w-full">
          <a
            target="_blank"
            className="text-neutral-400 hover:text-white text-sm transition-all duration-300 py-1 flex items-center gap-2 hover:gap-3"
            href="https://www.epicweb.dev/talks/whats-new-in-react-19-and-how-to-use-it"
            rel="noreferrer"
          >
            <ArrowTopRightOnSquareIcon width={16} />
            Enjoy the talk here!
          </a>
        </div>
      </div>
    </div>
  );
}
